import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStyledComponentsComponent } from './simple-icons-styled-components.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStyledComponentsComponent ],
    exports:      [ SimpleIconsStyledComponentsComponent ],
    bootstrap:    []
})
export class SimpleIconsStyledComponentsModule {}
